import React from 'react';
import './Confirmation.css';
import NumberFormat from "react-number-format";
import SummaryCharges from "../summary-charges/summary-charges";
import Helmet from "react-helmet/es/Helmet";

class Confirmation extends React.Component {

    constructor(props) {
        super(props);
        this.state = {}

        /*window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'VirtualPageview',
            'virtualPageURL': 'gaVirtualPageURL',
            'virtualPagePath': '/',
            'virtualPageTitle': 'Payment Confirmation Page'
        });*/

        this.paymentConfirmation = this.props.paymentConfirmation;

        window.dataLayer = window.dataLayer || [];
        try {
            var oneTrust = window.OnetrustActiveGroups;
			if ( this.getSitePropertyValue('ONE_TRUST_SNIPPET_COOKIE_LOADER') !== 'N' && oneTrust && oneTrust.includes('C0004')) {
			    window.dataLayer.push({
                    'event': 'VirtualPageview',
                    'virtualPageURL': 'gaVirtualPageURL',
                    'virtualPagePath': '/css/guest/payment_confirmation.do',
                    'virtualPageTitle': 'Customer Self Service'//,
                });
			} else if (this.getSitePropertyValue('ONE_TRUST_SNIPPET_COOKIE_LOADER') === 'N') {
                window.dataLayer.push({
                    'event': 'VirtualPageview',
                    'virtualPageURL': 'gaVirtualPageURL',
                    'virtualPagePath': '/css/guest/payment_confirmation.do',
                    'virtualPageTitle': 'Customer Self Service'//,
                });
			} else {
				console.log("off");    
			}
          
        } catch (error) {
            //swallow error
        }

    }

    render = () => {
        const charges = {

            totalWithOutInsurance: this.paymentConfirmation.totalWithOutInsurance,
            insuranceTotal: this.paymentConfirmation.insuranceTotal,
            paymentsReceived: this.paymentConfirmation.paymentsReceived,
            pendingPaymentTotal: this.paymentConfirmation.pendingPaymentTotal,
            remainingBalanceIncludingInsurance: this.paymentConfirmation.remainingBalanceIncludingInsurance,
            remainingBalanceExcludingInsurance: this.paymentConfirmation.remainingBalanceExcludingInsurance,
            //nextPaymentDueDate: paymentConfirmation.nextPaymentDueDate,
            finalPaymentDate: this.paymentConfirmation.finalPaymentDate,
            includeInsurance: this.paymentConfirmation.includeInsurance,
            currentAmount: 0 //paymentConfirmation.paymentAmount

            /*// totalWithOutInsurance: this.booking.totalWithOutInsurance,
            paymentAmount: paymentConfirmation.paymentAmount,
            insuranceTotal: paymentConfirmation.insuranceTotal,
            paymentsReceived: paymentConfirmation.previousPayments,
            pendingPaymentTotal: paymentConfirmation.pendingPayments,
            //remainingBalanceIncludingInsurance: this.booking.remainingBalanceIncludingInsurance,
            nextPaymentDueDate: paymentConfirmation.nextPaymentDueDate,
            finalPaymentDate: paymentConfirmation.finalPaymentDate,
            currentAmount: paymentConfirmation.paymentAmount,
            includeInsurance: paymentConfirmation.includeInsurance*/
        }
        window.scrollTo(0, 0);
        return (
            <div className="rea-appContainer">
                <Helmet>
                    <title>Customer Self Service / Confirmatione</title>
                </Helmet>
                <div className="rea-confirmation rea-block-row">
                    <div className="rea-block-12 rea-thankYouContainer">
                        <div className="rea-block-12">
                            <div className="rea-thankYouGreen">Thank you for your payment of <NumberFormat
                                value={this.paymentConfirmation.paymentAmount} displayType={'text'}
                                thousandSeparator={true} decimalScale='2'
                                fixedDecimalScale='true'
                                prefix={'$'}/> for order # {this.paymentConfirmation.bookingNumber}</div>
                            <div className="rea-thankYouText">
                                This payment will be credited to your booking once it is processed. Your vacation specialist will follow up with you if additional information is required.
                            </div>
                            {/*<div>
                            Your updated summary of charges is listed below:
                        </div>*/}
                        </div>
                    </div>
                    <div className="rea-block-12">
                        <SummaryCharges charges={charges}/>
                    </div>
                    <div className="rea-block-12 rea-printPage">
                        Please <a href="# " className="rea-textLink" onClick={e=>{e.preventDefault();this.printPage()}}>print this page</a> for your
                        records.
                    </div>
                </div>
            </div>
        );
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    handleSubmit = (event) => {
        event.preventDefault();
        this.props.onMakeAnotherPaymentSubmit();
    }

    printPage = (event) => {
        window.print();
    }
    getSitePropertyValue = (propertyName) => {
    	let sitePropertyValue='';
    	for(let k=0; k<this.props.siteConfigData.siteProperties.length; k++){
    		if(this.props.siteConfigData.siteProperties[k].propertyName===propertyName){
    			sitePropertyValue = this.props.siteConfigData.siteProperties[k].propertyValue;
    		}
    	}
    	return sitePropertyValue;
    }

}

export default Confirmation;
